import { MarketData } from './market'

/** 出售数据 */
export interface SellData {
  tree: MarketData['tree']
  list: Array<{
    kid: number
    name: string
    overage: MarketData['overage']
    total: MarketData['total']
    price: MarketData['price']
    /** 收购价颜色 1 金色 2蓝色 3 绿色 */
    color: number
    uid: number
  }>
}

export function getDefaultSellData(): SellData {
  return {
    tree: 0,
    list: [],
  }
}

/** 最终调用接口的出售数据 */
export interface FinalSellData {
  source: 'market' | 'search'
  data: SellData['list'][number] | null
  tree: SellData['tree']
}

export function getDefaultFinalSellData(): FinalSellData {
  return {
    source: 'market',
    data: null,
    tree: 0,
  }
}

/** 出售记录 */
export interface SellRecord {
  /** 类型，1买 2卖 */
  category: 1 | 2
  coin: number
  date: number
  kid: number
  name: string
  tree: number
}

export const sellData: SellData = getDefaultSellData()

export const specifiedSellData: SellData = getDefaultSellData()

export const sellRecordList: SellRecord[] = []

export let sellCount: number = 0

export let targetPlayerId = ''
